import { Tariff } from '@/constants/tariff';

export const getAbTestsCost = (abTestsCount: number, maxAbTests: number, abTestsCosts: Tariff['abTestsCosts']): number => {
  if (!abTestsCosts) return 0;
  
  if (abTestsCount <= maxAbTests) return 0;
  
  const additionalAbTests = abTestsCount - maxAbTests;
  let totalCost = 0;

  for (const costItem of abTestsCosts) {
    // TODO: recalculate on backend
    if (additionalAbTests >= costItem.from && additionalAbTests <= costItem.to) {
      totalCost += costItem.price * abTestsCount;
      break;
    }
  }

  return totalCost;
};

export const getStoresCost = (salesStoresCount: number, maxStoresSales: number, storePrice: number): number => {
  if (salesStoresCount <= maxStoresSales) return 0;
  
  const additionalStores = salesStoresCount - maxStoresSales;
  return additionalStores * storePrice;
};

export const getPhrasesCost = (phrases: number, phrasesCosts: Tariff['phrasesCosts'] | null): number => {
  if (!phrasesCosts) return 0;
  
  const totalPhrases = phrases;
  
  let totalCost = 0;

  for (const costItem of phrasesCosts) {
    if (totalPhrases >= costItem.from && totalPhrases <= costItem.to) {
      totalCost = costItem.price;
      break;
    }
  }

  return totalCost;
};

export const getStoresAdvCost = (storesAdvCount: number, maxStoresAdv: number, storePrice: number): number => {
  if (storesAdvCount <= maxStoresAdv) return 0;
  
  const additionalStores = storesAdvCount - maxStoresAdv;

  return additionalStores * storePrice;
};

export const getSeoProjectsCost = (projectsCount: number, projectsCosts: Tariff['projectsCosts']): number => {
  if (!projectsCosts) return 0;
  
  let totalCost = 0;

  for (const costItem of projectsCosts) {
    if (projectsCount >= costItem.from && projectsCount <= costItem.to) {
      totalCost = costItem.price;
      break;
    }
  }

  return totalCost;
};